import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/playdata")({
  beforeLoad: () => {
    throw redirect({ href: "/ja/playdata" })
  },
})
